/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/sort_medium'
export default icon
